module.exports = __webpack_public_path__ + "static/media/dqIndexMobile.a73e0a81.png";